// extracted by mini-css-extract-plugin
export default {"playAgain":"PlayAgain_playAgain__ggtcW","logoXl":"PlayAgain_logoXl__8YORA","actions":"PlayAgain_actions__XNL+7"};